import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { formatShortFormDateInLocalTimezone } from "~/utils/datetime";
import * as styles from "./activityTimeline_vanilla.css";
import { getTextForHistoryEvent } from "./utils";
import type { HistoryEventType } from "~/graphql/supergraphTypes";

type HistoryEntry = {
  id: string;
  eventType: HistoryEventType;
  changedByName: string | null;
  changedAt: string;
};

type ActivityTimelineProps = {
  entries: HistoryEntry[];
};

export const ActivityTimeline = ({ entries }: ActivityTimelineProps) => {
  if (entries.length === 0) {
    return <Text variant="secondary-md">No activity yet.</Text>;
  }

  return (
    <Flex flexDirection="column" gap={12} className={styles.timelineContainer}>
      {entries.map((entry) => (
        <Flex key={entry.id} flexDirection="column" className={styles.timelineItem}>
          <Text>{getTextForHistoryEvent(entry.eventType, entry.changedByName)}</Text>
          <Text variant="secondary-sm">
            {formatShortFormDateInLocalTimezone(entry.changedAt)}
          </Text>
          <Icon type="check-circle" className={styles.timelineIcon} />
        </Flex>
      ))}
    </Flex>
  );
};
